import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ContentManagementService } from '../../../Services/content-management/content-management.service';
import { StudyMaterialModel } from 'src/app/Models/StudyMaterial';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { VStudyMaterial } from 'src/app/Validators/Validators';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { EMPTY, forkJoin, of, Subject, zip } from 'rxjs';
import { Injectable, ChangeDetectorRef } from '@angular/core';
import { UserAuthDetails } from 'src/app/Services/user-sessions/user-auth-details';
import {
  catchError,
  map,
  mergeMap,
  switchMap,
  takeUntil,
} from 'rxjs/operators';
import { IGetCodes } from 'src/app/interfaces/codes';
import { SessionService } from 'src/app/Services/session.service';
import {
  IApplicableExamList,
  ICourseCategoryType,
} from 'src/app/interfaces/interfaces/study-material';
import { ConstantVars } from 'src/app/utils/constants/constants';
import { ModalService } from 'src/app/Services/confirmation-modal/modalServie.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FilePreviewModalComponent } from 'src/app/common/file-preview-modal/file-preview-modal.component';
import { AssignPracticeQuestionStudyMaterialComponent } from '../../question-management/assign-practice-question-study-material/assign-practice-question-study-material.component';
import { NotificationAddEditComponent } from '../../notification-management/notification-add-edit/notification-add-edit.component';
import { ContentStudyUnitSubjectComponent } from '../content-study-unit-subject/content-study-unit-subject.component';
import { environment } from 'src/environments/environment';
//*import{ContentReviewcommentsComponent} from '../content-reviewcomments/content-reviewcomments.component';
export interface ICOURSEPLAN {
  Exam_Agency_ID: number;
  Exam_Agency_Name: string;
  Course_Master_Id: number;
  Course_Name: string;
  Course_Plan_ID: number;
  Course_Plan_Type_Code: string;
  Course_ID: number;
  Exam_Year: number;
  Study_Material_Id: number;
  Study_Unit_Id: number;
  Deleted_Ind: string;
  Course_Category_Type_Code: string;
}

@Component({
  selector: 'app-content-add-edit-studymaterial',
  templateUrl: './content-add-edit-studymaterial.component.html',
  styleUrls: ['./content-add-edit-studymaterial.component.css'],
})
export class ContentAddEditStudymaterialComponent implements OnInit {
  @Input('Close') Close: Subject<any>;
  @Input('Replace') Replace: Subject<any>;
  @Input('Close1') Close1: Subject<any>;
  @Input('Replace1') Replace1: Subject<any>;
  @Input('Closeclear') Closeclear: Subject<any>;
  @Input('Replaceclear') Replaceclear: Subject<any>;
  @Input('examAgencyId') ExamAgencyId: any;
  @Input('courseId') courseId: any;
  @Input() subjectById: any;
  @Input() CurrentstudyunitID: any;
  @Input() StudyMaterialDetails: any;
  @Input() EditStudyMaterialflag: any;
  @Input() AddStudyMaterialflag: any;

  @Input() ScreenName1: string;
  @Output() CloseandRefreshlist: EventEmitter<any> = new EventEmitter<any>();
  @Output() AlertPopup: EventEmitter<any> = new EventEmitter<any>();
  //@Output() DeleteAlertPopup : EventEmitter<any> = new EventEmitter<any>();
  @Output() ReplaceAlertPopup: EventEmitter<any> = new EventEmitter<any>();
  @Output() contentpreview: EventEmitter<any> = new EventEmitter<any>();
  @Output() contentreview: EventEmitter<any> = new EventEmitter<any>();
  @Output() ClickContentstatus: EventEmitter<any> = new EventEmitter<any>();
  @Output() Editstudymaterial: EventEmitter<any> = new EventEmitter<any>();
  @Output() CloseEditStudyMaterial: EventEmitter<any> = new EventEmitter<any>();
  @Output() closeWithOutRefreshing: EventEmitter<any> = new EventEmitter<any>();

  AddStudyMaterialform: FormGroup;
  COURSE_PLAN_TYPE: IGetCodes[];
  courseCategoryList: any = [];
  courseDifficultyType: any = [];
  courseList: any[];
  coursePlan: ICOURSEPLAN[] = [];
  courseYearList: any = [];
  examAgencyList: any = [];
  Filenameflag: boolean = false;
  globalstatus: string;
  InsertStudyMaterial: StudyMaterialModel;
  replace1: boolean = false;
  StudyMaterialStatus: string = 'WIP';
  tempvariable: boolean = false;
  todayDate: Date = new Date();
  versionOptions: number[] = Array.from({ length: 100 }, (_, i) => i + 1);
  firstTime: boolean = true;
  firstLoad: boolean = true;
  initialFormValues: string = '';
  private pendingInitOps = 0;
  isOnClose = false;
  private destroy$ = new Subject<void>();
  disableSaveButton = true;
  disableSaveButtonForApplicableCoursePlan = true;
  initialSelectedSnapshot: any;
  initialSelectedSnapshotForApplicableCourse: any;
  public env = environment;
  private readonly FIELDS_TO_TRACK = [
    'Study_Material_Type_Code',
    'Study_Material_Level_Type',
    'Study_Material_Name',
    'Study_Material_Status_Type_Code',
    'Version_Number',
    'Free_Resource_Ind',
    'ReferenceStudyMaterialInd',
    'PrimaryStudyMaterialInd',
    'Duration_In_Minutes',
    'NumberOfPages',
    'Display_Name',
    'File_Name',
    'FileUpload',
    'StudyMaterialId',
    'Study_Material_Difficulty_Level_Type',
    'File_Location_Name',
    'File_Location_NameAndFileName',
    'Study_Material_Url',
    'File_Object_Id',
    'File_Name_In_Server',
    'File_Del_Ind',
    'File_Source_Modified_Datetime',
    'File_Type_Code',
    'File_Type_Name',
    'Description_Text',
  ];
  private readonly FIELDS_TO_TRACK_FOR_APPLICABLE_COURSE = [
    'Course_Category_Type',
    'Applicable_Exam_List',
    'Applicable_Job_List',
  ];

  constructor(
    private cdr: ChangeDetectorRef,
    public pipe: DatePipe,
    public service: ContentManagementService,
    private fb: FormBuilder,
    private toaster: ToastrService,
    public session: SessionService,
    private modalService: ModalService,
    private ngModalService: NgbModal
  ) {
    this.todayDate = new Date(
      this.todayDate.setDate(this.todayDate.getDate() - 1)
    );
    //*  this.globalstatus=ContentReviewcommentsComponent.currentstudymaterialstatus;
  }

  ngOnInit() {
    this.InitializeForm();
    this.AddStudyMaterialform.get(
      'Study_Material_Type_Code'
    )?.valueChanges.subscribe((value) => {
      if (value === 'ClassVideo' || value === 'Sup-Video') {
        this.AddStudyMaterialform.get('NumberOfPages')?.disable();
        this.AddStudyMaterialform.get('NumberOfPages')?.setValue(0);
      } else {
        this.AddStudyMaterialform.get('NumberOfPages')?.enable();
        this.AddStudyMaterialform.get('NumberOfPages')?.setValue(0);
      }
    });

    this.getBreadcrumbDetails();
    this.getMaterial();
    this.getStatus();
    this.getMaterialLevel();
    this.Descriptioncount();
    this.fetchCoursePlanTypes();
    if (this.EditStudyMaterialflag) {
      this.getStudyMaterial(this.StudyMaterialDetails.Study_Material_Id);
    }

    if (this.EditStudyMaterialflag) {
      this.Close.subscribe((e) => {
        this.AddStudyMaterialform.controls['File_Name'].setValue(null);
        this.Filenameflag = false;
      });
      this.Replace.subscribe((e) => {
        this.FileValidation();
        if (!this.error1.isError && !this.error.isError) {
          //if(this.currentInput!=null){
          this.Filenameflag = true;
          //}
        } else {
          this.Filenameflag = false;
        }
      });
    }
    this.Close1.subscribe((e) => {});
    this.Replace1.subscribe((e) => {
      //this.replace1=true;
      if (!this.save_submitted1) {
        this.AddStudyMaterial1();
      }

      this.hiddenfilename = true;
    });
    this.Closeclear.subscribe((e) => {});
    this.Replaceclear.subscribe((e) => {
      this.AddStudyMaterialform.controls['File_Name'].setValue(null);
      this.AddStudyMaterialform.controls['File_Location_Name'].setValue(null);
      this.AddStudyMaterialform.controls[
        'File_Location_NameAndFileName'
      ].setValue(null);
    });

    this.getLists();
    if (this.AddStudyMaterialflag) {
      this.disableSaveButton = false;
      this.initialFormValues = JSON.stringify(
        this.AddStudyMaterialform.getRawValue()
      );
    }
  }

  checkMainFormDirty() {
    const controlsToWatch = [
      'Study_Material_Type_Code',
      'Study_Material_Level_Type',
      'Study_Material_Name',
      'Study_Material_Status_Type_Code',
      'Version_Number',
      'Free_Resource_Ind',
      'ReferenceStudyMaterialInd',
      'PrimaryStudyMaterialInd',
      'Duration_In_Minutes',
      'NumberOfPages',
      'Display_Name',
      'File_Name',
      'FileUpload',
      'StudyMaterialId',
      'Study_Material_Difficulty_Level_Type',
      'File_Location_Name', // disabled is fine; emits when you set its value programmatically
      'File_Location_NameAndFileName', // disabled is fine
      'Study_Material_Url',
      'File_Object_Id', // disabled is fine
      'File_Name_In_Server',
      'File_Del_Ind',
      'File_Source_Modified_Datetime',
      'File_Type_Code',
      'File_Type_Name',
      'Description_Text',
    ];
    controlsToWatch.forEach((controlName) => {
      const control = this.AddStudyMaterialform.get(controlName);
      if (control) {
        control.valueChanges
          .pipe(takeUntil(this.destroy$))
          .subscribe((value) => {
            // Your logic here
            // console.log(controlName, 'changed:', value);
            this.disableSaveButton = !this.hasFormChangedForMainForm();
          });
      }
    });
  }

  checkApplicableCourseForm() {
    const controlsToWatch = ['Course_Category_Type', 'Applicable_Exam_List'];
    controlsToWatch.forEach((controlName) => {
      const control = this.AddStudyMaterialform.get(controlName);
      if (control) {
        control.valueChanges
          .pipe(takeUntil(this.destroy$))
          .subscribe((value) => {
            // Your logic here

            this.disableSaveButtonForApplicableCoursePlan =
              !this.hasFormChangedForMApplicableCourseForm();
          });
      }
    });
  }


  get showStudyMaterialUrl(): boolean {
  const delInd = this.AddStudyMaterialform.get('File_Del_Ind')?.value;
  const fileUploadValue = this.AddStudyMaterialform.get('FileUpload')?.value;
  const FileNameInServer = this.AddStudyMaterialform.get('File_Name_In_Server')?.value;

  return (!FileNameInServer || delInd === 'Y') && !fileUploadValue;
}




  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public async OnClose() {

    if (this.hasFormChanged()) {
      try {
        const result = await this.modalService.open(
          'Confirmation',
          `You have unsaved changes. Do you want to save before leaving?`
        );
        if (result) {
          this.isOnClose = true;
          this.AddStudyMaterial();
          this.AssigntoCourses();
        } else {
          if (this.EditStudyMaterialflag) {
            this.closeWithOutRefreshing.emit();
          } else {
            this.CloseEditStudyMaterial.emit();
          }
        }
      } catch (error) {
        console.log('Modal dismissed:', error);
      }
    } else {
      if (this.EditStudyMaterialflag) {
        this.closeWithOutRefreshing.emit();
      } else {
        this.CloseandRefreshlist.emit()
      }
    }
  }

  InitializeForm() {
    //const reg = '(http?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
    this.AddStudyMaterialform = this.fb.group({
      Study_Material_Type_Code: ['', VStudyMaterial],
      Study_Material_Level_Type: ['', VStudyMaterial],
      Study_Material_Name: ['', VStudyMaterial],
      Study_Material_Status_Type_Code: [''],
      Version_Number: [],
      Free_Resource_Ind: [false],
      ReferenceStudyMaterialInd: [false],
      PrimaryStudyMaterialInd: [false],
      Duration_In_Minutes: [0, Validators.required],
      NumberOfPages: [0],
      Display_Name: ['', Validators.required],
      File_Name: [null],
      FileUpload: [],
      StudyMaterialId: [],
      Study_Material_Difficulty_Level_Type: [null, Validators.required],

      //File_Location_Name:["",[Validators.pattern(reg)]],
      File_Location_Name: [{ value: '', disabled: true }],
      File_Location_NameAndFileName: [{ value: '', disabled: true }],
      Study_Material_Url: ['',[Validators.pattern(/^https?:\/\/.+$/)]],
      File_Object_Id: [{ value: '', disabled: true }],
      File_Object_Id_Temp: [{ value: '', disabled: true }],
      File_Name_In_Server: [],
      StudyMaterialArchivedInd:[],
      File_Del_Ind: ['N'],
      File_Source_Modified_Datetime: [],
      File_Type_Code: [],
      File_Type_Name: [],
      Description_Text: [''],
      Course_Category_Type: this.fb.array([]),
      Applicable_Exam_List: this.fb.array([]),
      Applicable_Job_List: this.fb.array([
        this.fb.group({
          courseId: [''],
          // examAgency: val.examAgency,
          examAgency: [],
          examYear: [],
          deleteInd: ['N'],
          courseList: [],
          courseYear: [],
          examAgencyList: [],
        }),
      ]),
    });
  }

  AssignPracticeQuestions() {
    const modalRef = this.ngModalService.open(
      AssignPracticeQuestionStudyMaterialComponent,
      {
        centered: true,
        size: 'lg',
        windowClass: 'custom-modal-width-relation',
      }
    );

    modalRef.componentInstance.studyMaterial = this.StudyMateriallist;
  }

  ManageRelatedTopics() {
    const modalRef = this.ngModalService.open(
      ContentStudyUnitSubjectComponent,
      {
        centered: true,
        size: 'lg',
        windowClass: 'custom-modal-related-topics',
      }
    );

    modalRef.componentInstance.SubjectlistID = this.CurrentstudyunitID;
    modalRef.componentInstance.subjectById = this.subjectById;
    modalRef.componentInstance.StudyUnit = { ID: this.CurrentstudyunitID };
    modalRef.componentInstance.headingLabel = 'Topics Covered in Study Material';
    modalRef.componentInstance.headingBgColor = '#8080801c';
    modalRef.componentInstance.showHeaderCloseButton = true;

    modalRef.result.then(
      (result) => {
        // Handle close result if needed
        console.log('Topics modal closed:', result);
      },
      (reason) => {
        // Handle dismiss reason if needed
        console.log('Topics modal dismissed:', reason);
      }
    );
  }

  fetchCourseBasedOnExam(appInstance: any, item: any) {
    this.service
      .GetCode({
        Tablename: `EXAM_COURSE@${appInstance.value.examAgency}@Course_Category_Type@${item.Code}`,
      })
      .subscribe((elem) => {
        appInstance.get('courseList').setValue(elem || []);
        appInstance.get('courseYear').setValue([]);
        appInstance.get('coursePlan').setValue([]);
        appInstance.get('selectedCoursePlan').clear();
      });
  }

  getExamAgencyList(item: any, index: number) {
    this.service
      .GetCode({
        Tablename: `EXAM_AGENCY@${item.Code}`,
      })
      .subscribe((elem) => {});
  }
  CheckIfCourseType(type: string) {
    const FormArray = this.AddStudyMaterialform.get(
      'Applicable_Exam_List'
    ) as FormArray as any;

    return FormArray.value.some((e: any) => e.type === type);
  }
  getFormControlsByName(controlName: string, item?: any) {
    const formA = this.AddStudyMaterialform.get(
      controlName
    ) as FormArray as any;
    return formA;
  }
  addCourseCategoryType(ccName: string, ccType: string, selectedInd: boolean) {
    (this.AddStudyMaterialform.get('Course_Category_Type') as FormArray)?.push(
      this.fb.group({
        CourseCategoryTypeCode: [ccType],
        SelectedInd: [selectedInd],
        CourseCategoryTypeName: [ccName],
      })
    );
  }
  addApplicableExamList(val: any, examValue?: any) {
    this.service
      .GetCode({
        Tablename: `EXAM_AGENCY@${
          val.type || examValue?.Course_Category_Type_Code
        }`,
      })
      .subscribe((elem: any) => {
        if (
          this.validateSelectedCoursePlans(
            this.AddStudyMaterialform.get('Applicable_Exam_List')?.value,
            val.type
          )
        ) {
          return; // Stop execution if validation fails
        }

        (
          this.AddStudyMaterialform.get('Applicable_Exam_List') as FormArray
        )?.push(
          this.fb.group({
            courseId: [
              val?.courseId || examValue?.Course_ID,
              Validators.required,
            ],
            // examAgency: val.examAgency,
            examAgency: [examValue?.Exam_Agency_ID, Validators.required],
            examYear: [examValue?.Exam_Year, Validators.required],
            deleteInd: [val?.deleteInd || 'N'],
            courseList: [],
            courseYear: [],
            coursePlan: [],
            selectedCoursePlan: this.fb.array([]),
            type: [val.type],
            examAgencyList: [elem],
          })
        );
      });
  }

  validateSelectedCoursePlans(examData: any[], newType: string): boolean {
    let hasValidCoursePlan = false; // Track if at least one valid object exists

    // Filter out objects where deleteInd is 'N' and match the same type
    let validData = examData.filter(
      (item) => item.deleteInd === 'N' && item.type === newType
    );
    hasValidCoursePlan = validData.every((item) => {
      return item.selectedCoursePlan && item.selectedCoursePlan.length > 0;
    });

    // Show error if no valid selectedCoursePlans exist for this type
    if (!hasValidCoursePlan) {
      this.toaster.error(
        `You cannot add a new row for type "${newType}" because all existing ones have empty selected course plans.`,
        'Error',
        { timeOut: 5000 }
      );
      return true; // Prevent adding new object
    }

    console.log(`Valid selected course plans exist for type "${newType}".`);
    return false; // Allow adding new object
  }

  deleteApplicableExamList(index: number, code: string) {
    const internalCode =
      this.AddStudyMaterialform.getRawValue().Applicable_Exam_List.find(
        (accu: any) => accu.type === code
      );

    if (internalCode.courseId) {
      (this.AddStudyMaterialform.get('Applicable_Exam_List') as FormArray)
        .at(index)
        .get('deleteInd')
        ?.setValue('Y');

      this.AddStudyMaterial(index, code, internalCode);
    }
  }

  isActivated(code: string) {
    const courseCode =
      this.AddStudyMaterialform.value.Course_Category_Type.find(
        (accu: any) => accu.CourseCategoryTypeCode === code
      );
    return courseCode?.SelectedInd;
  }

  fetchCourseYear(appExam: any, item: any) {
    this.service
      .GetCode({
        Tablename: `COURSE_YEAR@${appExam.value.courseId}@${item.Code}`,
      })
      .subscribe((elem) => {
        appExam.get('courseYear').setValue(elem || []);
        appExam.get('coursePlan').setValue([]);
        appExam.get('examYear').setValue([]);
        appExam.get('selectedCoursePlan').clear();
      });
  }
  fetchCoursePlanTypes() {
    this.service
      .GetCode({
        Tablename: `COURSE_PLAN_TYPE`,
      })
      .subscribe((elem) => {
        console.log(elem);
        this.COURSE_PLAN_TYPE = elem;
        // appExam.get('courseYear').setValue(elem || []);
      });
  }
  getLists() {
    forkJoin([
      this.service.getDropdownListByCode('COURSE_CATEGORY_TYPE'),
      this.service.getDropdownListByCode('YEAR'),
      this.service.getExamAgencyList(UserAuthDetails.getUserLoggedInId()),
      this.service.getDropdownListByCode(
        'STUDY_MATERIAL_DIFFICULTY_LEVEL_TYPE'
      ),
      // this.service.GetCode({ Tablename: 'EXAM_AGENCY' }),
    ]).subscribe((listData) => {
      const [courseCategoryType, examYear, agencyList, courseDifficultyType] =
        listData;

      this.examAgencyList = agencyList;
      this.courseList = [];
      this.courseYearList = examYear;
      this.courseCategoryList = courseCategoryType;
      this.courseDifficultyType = courseDifficultyType;

      (
        this.AddStudyMaterialform.get('Course_Category_Type') as FormArray
      ).clear();

      (courseCategoryType as any).forEach((elem: any) => {
        this.addCourseCategoryType(elem.Description, elem.Code, false);
      });
      if (this.AddStudyMaterialflag) {
        this.disableSaveButton = false;
        this.initialFormValues = JSON.stringify(
          this.AddStudyMaterialform.getRawValue()
        );
      }
    });
  }

  getCoursePlan(index: number, selectedCoursePlans?: any[]) {
    const courseId = this.getFormControlsByName('Applicable_Exam_List').at(
      index
    ).value.examYear;

    const formArray = this.getFormControlsByName(
      'Applicable_Exam_List'
    ) as FormArray;
    const formGroup = formArray.at(index) as FormGroup;
    const tempapplicableExams = formArray.value;
    if (this.checkDuplicateExamYear(tempapplicableExams)) {
      const formGroup = formArray.at(index) as FormGroup;
      const courseList = formGroup.get('courseList')?.value;
      const courseId = formGroup.get('courseId')?.value;
      const courseName =
        courseList.find((e: any) => +e.Code === +courseId)?.Description ?? '';
      //  Retrieve the examYear from the FormGroup
      formGroup.get('examYear')?.reset();
      formGroup.get('coursePlan')?.setValue([]);
      formGroup.get('selectedCoursePlan')?.reset([]);
      this.toaster.error(
        `Course year is already selected for "${courseName}" `,
        'Error',
        {
          timeOut: 5000,
        }
      );
      return;
    }
    this.service
      .getCoursePlan$(
        this.session.getUser(),
        courseId,
        '',
        'ASSIGNSTUDYMATERIAL',
        '',
        ''
      )
      .subscribe(
        (res: any) => {
          if (formGroup) {
            // Update coursePlan array
            formGroup.get('coursePlan')?.patchValue(res?.coursePlan);

            // Clear selectedCoursePlan and repopulate dynamically
            const selectedCoursePlanArray = formGroup.get(
              'selectedCoursePlan'
            ) as FormArray;

            selectedCoursePlanArray.clear(); // Clear existing controls
            if (selectedCoursePlans) {
              res?.coursePlan.forEach((plan: any) => {
                // Check if a matching plan exists in selectedArray with Deleted_Ind === 'N'
                const isSelected = selectedCoursePlans.some(
                  (selectedPlan) =>
                    selectedPlan.Course_Plan_ID === plan.Course_Plan_Id &&
                    selectedPlan.Deleted_Ind === 'N'
                );

                selectedCoursePlanArray.push(
                  this.fb.group({
                    CoursePlanTypeCode: [plan.Course_Plan_Type_Code],
                    CourseID: [plan.Course_Id ?? courseId], // Assuming courseId is plan.Course_Id
                    SelectedInd: [isSelected], // Set based on the condition
                  })
                );
              });
            } else {
              res?.coursePlan.forEach((plan: any) => {
                selectedCoursePlanArray.push(
                  this.fb.group({
                    CoursePlanTypeCode: [plan.Course_Plan_Type_Code],
                    CourseID: [courseId],
                    SelectedInd: [false], // Add default selection status (unchecked)
                  })
                );
              });
            }
          }
        },
        (error) => {
          console.error(error);
          if (selectedCoursePlans) {
            this.afterInitStepDone();
          }
        },
        () => {
          if (selectedCoursePlans) {
            this.afterInitStepDone();
          }
        }
      );
  }
  checkDuplicateExamYear = (data: any[]) => {
    const examYearCount = new Map();
    const filtered = data.filter((e) => e.deleteInd === 'N');
    for (const item of filtered) {
      if (examYearCount.has(+item.examYear)) {
        return true; // Found a duplicate
      }
      examYearCount.set(+item.examYear, 1);
    }

    return false;
  };
  isCoursePlanSelected(appExam: FormGroup, itemCode: string): boolean {
    const selectedCoursePlans = appExam.get('selectedCoursePlan')?.value || [];
    return selectedCoursePlans.some(
      (plan: any) => plan.CoursePlanTypeCode === itemCode && plan.SelectedInd
    );
  }

  updateSelectedCoursePlan(item: any, appExam: FormGroup, event: any) {
    const isChecked = event.target.checked;
    const selectedCoursePlanArray = appExam.get(
      'selectedCoursePlan'
    ) as FormArray;
    // Find the index of the course plan to update
    const planIndex = selectedCoursePlanArray.controls.findIndex(
      (control) => control.get('CoursePlanTypeCode')?.value === item.Code
    );

    if (planIndex !== -1) {
      // Update the SelectedInd value
      selectedCoursePlanArray.at(planIndex).patchValue({
        SelectedInd: isChecked,
      });
    }
  }

  checkIfEnabled(item: IGetCodes, row: any) {
    if (row.value.coursePlan && row.value.coursePlan.length) {
      if (
        row.value.coursePlan.some(
          (e: any) => e.Course_Plan_Type_Code === item.Code
        )
      ) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  //#region DeleteCourses


deleteApplicablecourse(appExam: any) {
  const formGroup = appExam as FormGroup;
  const formGroupValue = formGroup.value;

  // 1) Clear selected plans on this row
  const changedSelectedCoursePlans = (formGroupValue.selectedCoursePlan || []).map(
    (e: any) => ({ ...e, SelectedInd: false })
  );
  formGroup.get('selectedCoursePlan')?.setValue(changedSelectedCoursePlans);

  // 2) Mark this row as deleted + relax validators for this row
  formGroup.get('deleteInd')?.setValue('Y');
  ['courseId', 'examAgency', 'examYear'].forEach((field) => {
    formGroup.get(field)?.removeValidators(Validators.required);
    formGroup.get(field)?.updateValueAndValidity({ onlySelf: true });
  });

  // 3) If this was the LAST remaining row of that course category, uncheck the category
  const currentType = formGroup.get('type')?.value;           // you set this as item.Code when adding rows
  const appExamArray = formGroup.parent as FormArray;         // siblings within Applicable_Exam_List
  if (!appExamArray) { return; }

  // After marking this one deleted, check if any NON-deleted rows remain for the same type
  const anyActiveForType = appExamArray.controls.some((ctrl) =>
    ctrl.get('type')?.value === currentType && ctrl.get('deleteInd')?.value !== 'Y'
  );

  if (!anyActiveForType && currentType != null) {
    // Go up to the root form to find Course_Category_Type
    const rootForm = appExamArray.parent as FormGroup;
    const courseCategoryFA = rootForm?.get('Course_Category_Type') as FormArray;

    if (courseCategoryFA) {
      // Try common key names for the category code; adjust if your key differs
      const targetCategory = courseCategoryFA.controls.find((c) => {
        const g = c as FormGroup;
        return (
          g.get('Code')?.value === currentType ||
          g.get('CourseCategoryTypeCode')?.value === currentType ||
          g.get('Type')?.value === currentType
        );
      });

      // Uncheck the category
      targetCategory?.get('SelectedInd')?.setValue(false);
      targetCategory?.get('SelectedInd')?.updateValueAndValidity({ onlySelf: true });
    }
  }
}

  async onCourseCategoryTypeChange(event: any, ccType: FormGroup) {
    const formGroup: ICourseCategoryType = ccType.value;
    const cCategoryType = formGroup.CourseCategoryTypeCode;
    const formArray = this.AddStudyMaterialform.get(
      'Applicable_Exam_List'
    ) as FormArray;

    if (!event.target.checked) {
      try {
        const result = await this.modalService.open(
          'Confirmation',
          `Do you want to remove the Applicable Course Type "${formGroup.CourseCategoryTypeName}"?`
        );

        if (result) {
          // Iterate through the FormArray and remove matching FormGroups
          for (let i = formArray.length - 1; i >= 0; i--) {
            const group = formArray.at(i).value;
            if (group.type === cCategoryType) {
              formArray.removeAt(i); // Remove FormGroup at index
            }
          }
        } else {
          // User canceled, programmatically re-check the checkbox
          ccType.get('SelectedInd')?.setValue(true);
        }
      } catch (error) {
        console.log('Modal dismissed:', error);
        // Modal dismissed, re-check the checkbox
        ccType.get('SelectedInd')?.setValue(true);
      }
    } else {
      this.service
        .GetCode({
          Tablename: `EXAM_AGENCY@${cCategoryType}`,
        })
        .subscribe((elem: any) => {
          (
            this.AddStudyMaterialform.get('Applicable_Exam_List') as FormArray
          )?.push(
            this.fb.group({
              // examAgency: val.examAgency,
              courseId: ['', Validators.required],
              examAgency: ['', Validators.required],
              examYear: ['', Validators.required],
              deleteInd: ['N'],
              courseList: [],
              courseYear: [],
              coursePlan: [],
              selectedCoursePlan: this.fb.array([]),
              type: [cCategoryType],
              examAgencyList: [elem],
            })
          );
        });
    }
  }

  ngAfterContentChecked(): void {
    this.cdr.detectChanges();
  }

  Breadcrumblist: any;
  Breadcrumb: string;
  ID: number;
  getBreadcrumbDetails() {
    if (this.EditStudyMaterialflag) {
      this.ID = this.CurrentstudyunitID;
    }
    if (this.AddStudyMaterialflag) {
      this.ID = this.CurrentstudyunitID;
    }
    this.service
      .getBreadcrumb({
        ID: this.subjectById?.Subject_Id,
        Screenname: 'CONTENT_MANAGEMENT',
      })
      .subscribe(
        (i: any) => {
          this.Breadcrumblist = i;
          this.Breadcrumb = this.Breadcrumblist.Data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  StudyMateriallist: any;
  StudyMaterial: any;
  currentInput: any;
  modifydatetime: any;
  videourlflag: boolean = false;
  filetypecode: string;
  hiddenfilename: boolean = false;
  // #region GET STUDYMATERIAL
  getStudyMaterial(data: any) {
    this.service
      .GetStudyMaterial({
        StudyMaterialID: data,
        StudyMaterialStatusTypeCode: 'WIP',
        StudyUnitID: +this.ID,
      })
      .pipe(
        // Switch to the second observable chain when StudyMaterial is retrieved
        switchMap((studyMaterial: any) =>
          this.getStudyMaterialApplication(data, studyMaterial).pipe(
            map(([coursePlan, courseCategory]) => ({
              studyMaterialByID: studyMaterial?.StudyMaterial[0],
              coursePlan,
              courseCategory,
            }))
          )
        ),
        catchError((error) => {
          console.error('Error fetching study material:', error);
          return EMPTY;
        })
      )
      .subscribe(
        ({ studyMaterialByID, coursePlan, courseCategory }) => {
          const courseCategoryTypes = [coursePlan, courseCategory];
          this.coursePlan = coursePlan;
          this.StudyMaterial = {
            StudyMaterialByID: studyMaterialByID,
          };
          this.StudyMateriallist = studyMaterialByID;
          this.AddStudyMaterialform.patchValue({
            Study_Material_Type_Code:
              this.StudyMateriallist.Study_Material_Type_Code,
            Study_Material_Level_Type:
              this.StudyMateriallist.Study_Material_Level_Type_Code,
            Study_Material_Name: this.StudyMateriallist.Study_Material_Name,
            Study_Material_Status_Type_Code:
              this.StudyMateriallist.Study_Material_Status_Type_Code,
            Version_Number: this.StudyMateriallist?.Version_Number,
            Free_Resource_Ind:
              this.StudyMateriallist.Free_Study_Material_Ind === 'Y'
                ? true
                : false,
            ReferenceStudyMaterialInd:
              this.StudyMateriallist.Reference_Study_Material_Ind === 'Y'
                ? true
                : false,
            PrimaryStudyMaterialInd:
              this.StudyMateriallist?.Primary_Study_Material_Ind === 'Y'
                ? true
                : false,
            Duration_In_Minutes: this.StudyMateriallist?.Duration_In_Minutes,
            Display_Name: this.StudyMateriallist?.Display_Name,
            // File_Name: this.StudyMateriallist?.File_Name,

            StudyMaterialId: this.StudyMateriallist?.Study_Material_Id,
            Study_Material_Difficulty_Level_Type:
              this.StudyMateriallist?.Study_Material_Difficulty_Level_Type_Code,

            // //File_Location_Name:["",[Validators.pattern(reg)]],
            File_Location_Name: this.StudyMateriallist?.File_Location_Name,
            StudyMaterialArchivedInd:
              this.StudyMateriallist?.Study_Material_Archive_Ind || '',
            File_Location_NameAndFileName: [
              this.StudyMateriallist?.File_Location_Name,
              this.StudyMateriallist?.File_Name_In_Server,
            ].filter(Boolean).join('/'),
            File_Object_Id: this.StudyMateriallist?.File_Object_Id,
            File_Object_Id_Temp: this.StudyMateriallist?.File_Object_Id,
            File_Name_In_Server: this.StudyMateriallist?.File_Name_In_Server,
            File_Name: this.StudyMateriallist?.File_Name,
            File_Source_Modified_Datetime:
              this.StudyMateriallist?.File_Source_Modified_Datetime,
            File_Type_Code: this.StudyMateriallist?.File_Type_Code,
            File_Type_Name: this.StudyMateriallist?.File_Type_Name,
            NumberOfPages: this.StudyMateriallist?.Number_Of_Pages,
            Study_Material_Url:
              this.StudyMateriallist?.Study_Material_URL ?? '',
            // Description_Text: this.StudyMateriallist?.Description_Text,
          });
          this.AddStudyMaterialform.get('Description_Text')?.setValue(
            this.StudyMateriallist?.Description_Text
          );
          if (this.StudyMateriallist?.File_Name_In_Server) {
            this.AddStudyMaterialform.get('Study_Material_Url')?.disable();
          }
          if(courseCategory.length <= 0) {
            this.captureInitialFormState();
          }
          if(this.firstLoad || !this.hasFormChangedForMApplicableCourseForm()   ){
            this.firstLoad = false
          this.AddStudyMaterialform.value.Course_Category_Type.forEach(
            async (elem: any, index: number) => {
              const courseCateType = courseCategoryTypes[1] || [];
              const found = courseCateType.find(
                (accu: any) =>
                  accu.Course_Category_Type_Code ===
                  elem?.CourseCategoryTypeCode
              );
              if (!coursePlan) {
                this.captureInitialFormState();
              }

              if (found && found?.Selected_Ind === 'Y') {
                (
                  this.AddStudyMaterialform.get(
                    'Course_Category_Type'
                  ) as FormArray
                )
                  ?.at(index)
                  ?.get('SelectedInd')
                  ?.setValue(found?.Selected_Ind === 'Y' ? true : false);
                const dataValues = (courseCategoryTypes[0] || []).filter(
                  (caAccu: any) =>
                    caAccu.Course_Category_Type_Code ===
                    found.Course_Category_Type_Code
                );
                if (!dataValues) {
                }
                const filteredDataValues = dataValues.filter(
                  (e: any, index: number, self: any[]) =>
                    index ===
                    self.findIndex((item) => item.Course_ID === e.Course_ID)
                );
                const categoryList = await new Promise((resolve, rejecr) => {
                  // dataValues.forEach((dAccu: any, index: number) => {

                  if (filteredDataValues.length <= 0) {
                    this.captureInitialFormState();
                  }
                  filteredDataValues.forEach((dAccu: any, indy: number) => {
                    if (dAccu) {
                      (
                        this.AddStudyMaterialform.get(
                          'Applicable_Exam_List'
                        ) as FormArray
                      ).clear();

                      this.service
                        .GetCode({
                          Tablename: `EXAM_AGENCY@${dAccu.Course_Category_Type_Code}`,
                        })
                        .subscribe((elemE: any) => {
                          this.service
                            .GetCode({
                              Tablename: `EXAM_COURSE@${dAccu.Exam_Agency_ID}@${dAccu.Course_Category_Type_Code}`,
                            })
                            .subscribe((elemC: any) => {
                              this.service
                                .GetCode({
                                  Tablename: `COURSE_YEAR@${dAccu.Course_Master_Id}@${dAccu.Course_Category_Type_Code}`,
                                })
                                .subscribe((elemCY: any) => {
                                  (
                                    this.AddStudyMaterialform.get(
                                      'Applicable_Exam_List'
                                    ) as FormArray
                                  )?.push(
                                    this.fb.group({
                                      courseId: [
                                        dAccu?.Course_Master_Id,
                                        Validators.required,
                                      ],
                                      // examAgency: val.examAgency,
                                      examAgency: [
                                        dAccu?.Exam_Agency_ID,
                                        Validators.required,
                                      ],
                                      examYear: [
                                        dAccu?.Course_ID,
                                        Validators.required,
                                      ],
                                      deleteInd: [dAccu?.Deleted_Ind || 'N'],
                                      courseList: [elemC],
                                      courseYear: [elemCY],
                                      coursePlan: [],
                                      selectedCoursePlan: this.fb.array([]),
                                      type: [dAccu.Course_Category_Type_Code],
                                      examAgencyList: [elemE],
                                    })
                                  );
                                  if (
                                    this.AddStudyMaterialform.value
                                      .Applicable_Exam_List.length > 0
                                  ) {
                                    const Findex =
                                      this.AddStudyMaterialform.value.Applicable_Exam_List.findIndex(
                                        (item: any) =>
                                          item.examYear === dAccu?.Course_ID
                                      );
                                    if (Findex !== -1) {
                                      // mark that one async init step is starting
                                      this.pendingInitOps++;
                                      this.getCoursePlan(Findex, dataValues);
                                    } else {
                                    }
                                  } else {
                                  }

                                  if (index === dataValues.length - 1) {
                                    resolve(true);
                                  }
                                });
                            });
                        });
                    }
                  });

                  // }); FOR EACH END
                });
              } else {
                this.AddStudyMaterialform.value.Applicable_Exam_List.forEach(
                  (elem: any, index: number) => {
                    const valIndex =
                      this.AddStudyMaterialform.value.Applicable_Exam_List.findIndex(
                        (a: any) => !a.courseId && elem.type === a.type
                      );
                    const valIndexMax =
                      this.AddStudyMaterialform.value.Applicable_Exam_List.filter(
                        (a: any) => a.type === elem.type
                      );

                    if (valIndexMax.length > 1) {
                      if (valIndex >= 0) {
                        (
                          this.AddStudyMaterialform.get(
                            'Applicable_Exam_List'
                          ) as any
                        ).removeAt(valIndex);
                      }
                    }
                  }
                );
                // if (coursePlan) {
                //   this.captureInitialFormState();
                // }
              }
            }
          );
        }
        },
        (error) => {
          console.log(error);
        }
      );
  }

  private afterInitStepDone(): void {
    if (this.pendingInitOps > 0) {
      this.pendingInitOps--;
    }
    if (this.pendingInitOps === 0) {
      this.captureInitialFormState();
    }
  }

  private captureInitialFormState(): void {
    this.initialFormValues = JSON.stringify(
      this.AddStudyMaterialform.getRawValue()
    );

    this.initialSelectedSnapshot = this.snapshotSelectedFields();
    this.initialSelectedSnapshotForApplicableCourse =
      this.snapshotOfCourseApplicableFields();

    if (this.EditStudyMaterialflag) {
      this.checkMainFormDirty();
      this.checkApplicableCourseForm();
    }
  }

  private snapshotSelectedFields(): string {
    const raw = this.AddStudyMaterialform.getRawValue(); // includes disabled
    const subset: any = {};
    for (const key of this.FIELDS_TO_TRACK) {
      subset[key] = raw[key];
    }
    // stringify for fast deep compare
    return JSON.stringify(subset);
  }
  private snapshotOfCourseApplicableFields(): string {
    const raw = this.AddStudyMaterialform.getRawValue(); // includes disabled
    const subset: any = {};
    for (const key of this.FIELDS_TO_TRACK_FOR_APPLICABLE_COURSE) {
      subset[key] = raw[key];
    }
    // stringify for fast deep compare
    return JSON.stringify(subset);
  }

  hasFormChanged(): boolean {
    const current = JSON.stringify(this.AddStudyMaterialform.getRawValue());

    return current !== this.initialFormValues;
  }
  hasFormChangedForMainForm(): boolean {
    const current = this.snapshotSelectedFields();
    const changed = current !== this.initialSelectedSnapshot;

    return changed;
  }
  hasFormChangedForMApplicableCourseForm(): boolean {
    const current = this.snapshotOfCourseApplicableFields();
    const changed = current !== this.initialSelectedSnapshotForApplicableCourse;

    return changed;
  }

  deleteUploadedFileOrFile(fileInput: HTMLInputElement) {
    this.AddStudyMaterialform.get('FileUpload')?.setValue(null);
    if (this.AddStudyMaterialform.get('File_Object_Id')?.value) {
      this.AddStudyMaterialform.get('File_Del_Ind')?.setValue('Y');
      this.AddStudyMaterialform.get('File_Object_Id_Temp')?.setValue('');
      this.AddStudyMaterialform.get('File_Location_NameAndFileName')?.setValue('');
    }
    this.AddStudyMaterialform.get('Study_Material_Url')?.enable();
    fileInput.value = '';
    if (this.AddStudyMaterialform.get('File_Object_Id')?.value) {
      // this.AddStudyMaterial();
    }
  }
  getmaterial: any;
  getMaterial() {
    this.service.GetCode({ Tablename: 'Study_Material_Type' }).subscribe(
      (i: any) => {
        this.getmaterial = i;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getmateriallevel: any;
  getMaterialLevel() {
    this.service.GetCode({ Tablename: 'Study_Material_Level_Type' }).subscribe(
      (i: any) => {
        this.getmateriallevel = i;

        // }).catch((e:any)=>{
        //   this.getmateriallevel=null;
        // });
      },
      (error) => {
        console.log(error);
      }
    );
  }
  getstatus: any;
  getStatus() {
    this.service.GetCode({ Tablename: 'Study_Material_Status_Type' }).subscribe(
      (i: any) => {
        this.getstatus = i;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  save_submitted: boolean = false;
  StudyMaterialResponse: any;
  Modalclose: boolean;
  ReviewReasons: any;
  FileNameInServer: any;

  getFormData() {
    const formdata = new FormData();

    const formValue = this.AddStudyMaterialform.getRawValue();

    if (
      !formValue.FileUpload &&
      !formValue.File_Object_Id &&
      !formValue.Study_Material_Url
    ) {
      return this.toaster.error(
        'Either upload a file or a provide and URL for Study Material.'
      );
    }
    if (this.AddStudyMaterialform.getRawValue().FileUpload) {
      formdata.append(
        'file1',
        this.AddStudyMaterialform.getRawValue().FileUpload
      );
    }
    // formdata.append('StudyMaterialID', '');
    formdata.append(
      'DescriptionText',
      this.AddStudyMaterialform.value.Description_Text
    );
    // formdata.append('LoggedInUserID', 'Vel_S_Pil_1');
    formdata.append(
      'StudyMaterialID',
      this.AddStudyMaterialform.value.StudyMaterialId || ''
    );
    formdata.append('ExamAgencyIdForFileManagement', this.ExamAgencyId || '');
    formdata.append('CourseIdForFileManagement', this.courseId || '');
    formdata.append(
      'StudyMaterialLevelTypeCode',
      this.AddStudyMaterialform.value.Study_Material_Level_Type || ''
    );
    formdata.append(
      'StudyMaterialDifficultyLevelTypeCode',
      this.AddStudyMaterialform.value.Study_Material_Difficulty_Level_Type || ''
    );
    formdata.append(
      'StudyMaterialName',
      this.AddStudyMaterialform.value.Study_Material_Name || ''
    );
    formdata.append(
      'StudyMaterialStatusTypeCode',
      this.AddStudyMaterialform.value.Study_Material_Status_Type_Code || ''
    );
    formdata.append(
      'StudyMaterialTypeCode',
      this.AddStudyMaterialform.value.Study_Material_Type_Code || ''
    );
    formdata.append('StudyUnitID', (this.ID || '') + '');
    // formdata.append('sessionLanguageTypeCode', 'ENG');
    formdata.append(
      'DurationInMinutes',
      this.AddStudyMaterialform.value.Duration_In_Minutes || 0
    );
    formdata.append(
      'NumberOfPages',
      this.AddStudyMaterialform.getRawValue().NumberOfPages || 0
    );
    formdata.append(
      'FreeStudyMaterialInd',
      this.AddStudyMaterialform.value.Free_Resource_Ind ? 'Y' : 'N'
    );
    formdata.append(
      'ReferenceStudyMaterialInd',
      this.AddStudyMaterialform.value.ReferenceStudyMaterialInd ? 'Y' : 'N'
    );
    formdata.append(
      'DisplayName',
      this.AddStudyMaterialform.value.Display_Name || ''
    );
    formdata.append(
      'VersionNumber',
      this.AddStudyMaterialform.value.Version_Number || ''
    );
    formdata.append(
      'FileObjectId',
      this.AddStudyMaterialform.getRawValue().File_Object_Id
    );
    formdata.append(
      'FileName',
      this.AddStudyMaterialform.value.File_Name ?? ''
    );
    formdata.append(
      'StudyMaterialArchivedInd',
      this.AddStudyMaterialform.value.StudyMaterialArchivedInd  ??'Y'
    );
    formdata.append(
      'FileNameInServer',
      this.AddStudyMaterialform.value.File_Name_In_Server || ''
    );
    formdata.append(
      'FileSourceModifiedDateTime',
      this.AddStudyMaterialform.value.File_Source_Modified_Datetime ||''
    );
    formdata.append(
      'FileTypeCode',
      this.AddStudyMaterialform.value.File_Type_Code || ''
    );
    formdata.append(
      'StudyMaterialUrl',
      this.AddStudyMaterialform.getRawValue().Study_Material_Url ||''
    );
    formdata.append(
      'FileLocationName',
      this.AddStudyMaterialform.getRawValue().File_Location_Name||''
    );

    formdata.append('DeletedInd', 'N');
    formdata.append('StudyMaterialDeletedInd', this.AddStudyMaterialform.value.File_Del_Ind);

    formdata.append('Study_Material_Difficulty_Level_Type', 'Difficult');
    let cTypeLen = 0;

    const selectedCourseTypePlan = this.selectedCourseTypePlan(); // Cache function call

    formdata.append(
      'PrimaryStudyMaterialInd',
      this.AddStudyMaterialform.value.PrimaryStudyMaterialInd ? 'Y' : 'N'
    );
    const fd = formdata;
for (const [k, v] of (fd as any).entries()) {
  console.log(k, v);
}
    return formdata;
  }
  selectedCourseTypePlan() {
    const list = this.AddStudyMaterialform.value?.Applicable_Exam_List || [];
    const activeList = list.filter((item: any) => item?.deleteInd !== 'Y');
    const result = activeList.reduce(
      (acc: any, item: any) => {
        (item.selectedCoursePlan || []).forEach((plan: any) => {
          acc.push({
            ...plan,
            examYear: item.examYear,
            type: item.type,
          });
        });
        return acc;
      },
      []
    );

    return result ?? [];
  }

  async showMessage(message: string) {
    try {
      const result = await this.modalService.open(
        'Information',
        `${message}`,
        'Confirm',
        'Cancel',
        true
      );

      if (result) {
        // Iterate through the FormArray and remove matching FormGroups

      }
      this.CreateNotification()
    } catch (error) {
      console.log('Modal dismissed:', error);
    }
  }

  // #region CreateNotification
  async CreateNotification(): Promise<boolean> {
    try {
      // Step 1: Ask for confirmation
      const result = await this.modalService.open(
        'Confirmation',
        'Do you want to send notification to all the users about this Study Material change?',
        'Yes',
        'No'
      );

      if (!result) {
        return false; // user cancelled
      }

      // Step 2: Open notification modal
      const modalRef = this.ngModalService.open(NotificationAddEditComponent, {
        centered: true,
        size: 'xl',
        windowClass: 'custom-modal-width-notification',
        backdropClass: 'custom-backdrop-notification'
      });

      // Pass data into modal
      modalRef.componentInstance.screenName = 'StudyMaterial';
      modalRef.componentInstance.MaterialId = this.AddStudyMaterialform.getRawValue().StudyMaterialId;

      // Step 3: Wait for modal close result
      const notificationResult = await modalRef.result
        .then((res: any) => res)
        .catch(() => false);

      return !!notificationResult;
    } catch (error) {
      console.error('CreateNotification dismissed or failed:', error);
      return false;
    }
  }


  // #region  SaveStudyMaterial
  AddStudyMaterial(deleteIndex?: number, code?: any, internalCode?: any) {
    if (this.AddStudyMaterialform.valid) {
      const formValue = this.AddStudyMaterialform.getRawValue();
      if (
        (!formValue.FileUpload &&
        formValue.File_Del_Ind ==='Y')&&
        !formValue.Study_Material_Url
      ) {
        this.toaster.error(
          'Either upload a file or a provide a URL for Study Material.'
        );
        return;
      }
      this.service.CreateOrModifyStudyMaterial(this.getFormData()).subscribe(
        (i: any) => {
          this.AddStudyMaterialform.get('FileUpload')?.setValue(null);
          // this.AssigntoCourses();
          this.toaster.success('Saved Successfully', 'Success',{timeOut: ConstantVars.ToastSucessTimeout});
          if(this.EditStudyMaterialflag){
            this.CreateNotification()
          }
          if(!this.firstTime ){
            this.CreateNotification()
          }
          if (this.AddStudyMaterialflag && this.firstTime && !this.isOnClose) {
            setTimeout(() => {
              this.showMessage(
                'The new Study Material is assigned to ALL Course plan under the Course. if its not applicable to all Course Plans, please adjust it in this screen and Save by clicking Save Study Material Assign Button.'
              );
              this.firstTime = false;
            }, 1000);
          }

          this.AddStudyMaterialform.get('File_Del_Ind')?.setValue('N');
          this.AddStudyMaterialform.get('StudyMaterialId')?.setValue(
            i?.Data?.NewStudyMaterialId ||
              this.AddStudyMaterialform.value.StudyMaterialId
          );

          if (deleteIndex) {
            this.getFormControlsByName('Applicable_Exam_List').removeAt(
              deleteIndex
            );
            const length =
              this.AddStudyMaterialform.value.Applicable_Exam_List.filter(
                (accu: any) => accu.type === code
              ) ?? [];
          }
          if (!this.isOnClose) {

            this.getStudyMaterial(
              this.AddStudyMaterialform.value.StudyMaterialId
            );

          } else {
            if (this.EditStudyMaterialflag) {
              this.CloseandRefreshlist.emit();
            } else {
              this.CloseandRefreshlist.emit();
            }
          }
          this.initialSelectedSnapshot = this.snapshotSelectedFields();
          this.disableSaveButton= true
          this.StudyMaterialResponse = i;




          if (
            this.StudyMaterialResponse?.Data &&
            this.StudyMaterialResponse.Data?.NewStudyMaterialId
          ) {
          } else {
            this.toaster.error(this.StudyMaterialResponse.Message);
          }
        },
        (error) => {
          console.log(error);
        }
      );
    } else {
      this.AddStudyMaterialform.markAllAsTouched();
      this.toaster.error('Fill All highlighted Fields', '', {
        timeOut: 5000,
      });
    }
  }

  AssigntoCourses() {
    if (this.AddStudyMaterialform.valid) {
      const formdata = new FormData();
      let cTypeLen = 0;
      this.AddStudyMaterialform.value.Course_Category_Type.forEach(
        (elem: any, index: number) => {
          formdata.append(
            `UDTStudyMaterialApplicableCourseCategory[${cTypeLen}][CourseCategoryTypeCode]`,
            elem.CourseCategoryTypeCode
          );
          formdata.append(
            `UDTStudyMaterialApplicableCourseCategory[${cTypeLen}][StudyMaterialID]`,
            this.AddStudyMaterialform.get('StudyMaterialId')?.value
          );
          formdata.append(
            `UDTStudyMaterialApplicableCourseCategory[${cTypeLen}][SelectedInd]`,
            elem.SelectedInd ? 'Y' : 'N'
          );
          cTypeLen++;
        }
      );
      formdata.append(
        'UDTStudyMaterialApplicableCourseCategoryLength',
        cTypeLen + ''
      );

      let len = 0;

      // 1) Start from current active selections (ignoring deleted rows)
      const rawSelectedCoursePlan = [...this.selectedCourseTypePlan()];

      // 2) Dedupe by CourseID|CoursePlanTypeCode so each combination appears ONCE, keeping SelectedInd true if selected in any active row
      const planMap = new Map<string, any>();
      rawSelectedCoursePlan.forEach((plan: any) => {
        const key = `${plan.CourseID}|${plan.CoursePlanTypeCode}`;
        if (!planMap.has(key)) {
          planMap.set(key, { ...plan });
        } else {
          if (plan.SelectedInd) {
            planMap.get(key).SelectedInd = true;
          }
        }
      });

      const selectedCoursePlan = Array.from(planMap.values());
      const selectedKeys = new Set(planMap.keys());

      // 3) Add missing combos from full coursePlan as deselected rows
      this.coursePlan.forEach((cP) => {
        const key = `${cP.Course_ID}|${cP.Course_Plan_Type_Code}`;
        if (!selectedKeys.has(key)) {
          selectedCoursePlan.push({
            CoursePlanTypeCode: cP.Course_Plan_Type_Code,
            CourseID: cP.Course_ID,
            SelectedInd: false,
          });
          selectedKeys.add(key);
        }
      });

      selectedCoursePlan.forEach((elem: any, index: number) => {
        formdata.append(
          `UDTStudyMaterialApplicableCoursePlan[${len}][CoursePlanTypeCode]`,
          elem.CoursePlanTypeCode
        );
        formdata.append(
          `UDTStudyMaterialApplicableCoursePlan[${len}][StudyMaterialID]`,
          this.AddStudyMaterialform.get('StudyMaterialId')?.value
        );
        formdata.append(
          `UDTStudyMaterialApplicableCoursePlan[${len}][CourseID]`,
          String(elem.CourseID ?? '')
        );
        formdata.append(
          `UDTStudyMaterialApplicableCoursePlan[${len}][SelectedInd]`,
          elem.SelectedInd ? 'Y' : 'N'
        );
        len++;
      });
      formdata.append('UDTStudyMaterialApplicableCoursePlanLength', len + '');
      formdata.append('LoggedInUser', UserAuthDetails.getUserLoggedInId()); // Replace with the actual user ID

      this.service
        .InsertOrUpdateStudyMaterialApplicableCoursePlan$(formdata)
        .subscribe(
          (res) => {
            if (!this.isOnClose) {
              // this.getStudyMaterial(
              //   this.AddStudyMaterialform.get('StudyMaterialId')?.value
              // );
              this.captureInitialFormState()
              this.initialSelectedSnapshotForApplicableCourse =
              this.snapshotOfCourseApplicableFields();
              this.disableSaveButtonForApplicableCoursePlan = true
            }
          this.toaster.success('Saved Successfully', 'Success', {
              timeOut: ConstantVars?.ToastSucessTimeout,
            });
          },
          (error) => {
            console.log(error);
            this.toaster.error(error.error.Message, '', {
              timeOut: ConstantVars.ToastErrorTimeout,
            });
          }
        );
    } else {
      this.AddStudyMaterialform.markAllAsTouched();
      this.toaster.error('Fill All highlighted Fields', '', {
        timeOut: 5000,
      });
    }
  }

  save_submitted1: boolean = false;
  StudyMaterialResponse1: any;
  Modalclose1: boolean;
  ReviewReasons1: any;
  FileNameInServer1: any;
  AddStudyMaterial1() {
    // if(this.AddStudyMaterialform.valid){
    this.InsertStudyMaterial = this.AddStudyMaterialform.value;
    this.InsertStudyMaterial.Study_Unit_Id = this.CurrentstudyunitID;
    this.InsertStudyMaterial.Study_Material_Status_Type_Code =
      this.StudyMaterialDetails.Study_Material_Status_Type_Code;
    this.InsertStudyMaterial.File_Name = null;
    if (this.InsertStudyMaterial.File_Location_Name == '') {
      this.InsertStudyMaterial.File_Location_Name = null;
    }
    this.InsertStudyMaterial.File_Location_Name = null;
    this.InsertStudyMaterial.File_Type_Code = null;
    this.InsertStudyMaterial.Study_Unit_Id = this.CurrentstudyunitID;
    // this.InsertStudyMaterial.Study_Material_Status_Type_Code='WIP';
    //this.InsertStudyMaterial.File_Name=this.file.name;
    this.InsertStudyMaterial.FileSourceModifiedDateTime =
      this.todayDate.toISOString();
    this.InsertStudyMaterial.Study_Material_Id =
      this.StudyMateriallist.Study_Material_Id;
    this.InsertStudyMaterial.File_Object_Id =
      this.StudyMateriallist.File_Object_Id;
    this.InsertStudyMaterial.Deleted_Ind = 'N';

    this.service
      .CreateOrModifyStudyMaterial(this.InsertStudyMaterial)
      .subscribe(
        (i: any) => {
          this.StudyMaterialResponse1 = i;
          //this.FileNameInServer1=this.StudyMaterialResponse1.FileNameInServer;
          //this.FileNameInServer.Value = this.FileNameInServer.Value.substring(0, this.FileNameInServer.Value.lastIndexOf('.'));
          if (this.StudyMaterialResponse1.Message == 'Success') {
            this.toaster.success('File Deleted Successfully', '', {
              timeOut: 500,
            });

            this.save_submitted1 = true;
            if (this.EditStudyMaterialflag) {
              this.save_submitted1 = false;

              // this.InitializeForm();
              this.getBreadcrumbDetails();
              this.getMaterial();
              this.getStatus();
              this.getMaterialLevel();
              this.Descriptioncount();
              if (this.StudyMaterialDetails != null) {
                this.getStudyMaterial(
                  this.StudyMaterialDetails.Study_Material_Id
                );
              } else {
                this.getStudyMaterial(null);
              }

              this.Filenameflag = false;
              this.currentFile = undefined;
              this.hiddenfilename = true;

              //this.Replace1.unsubscribe();
            }
          } else {
            this.toaster.error(this.StudyMaterialResponse.Message);
            this.save_submitted1 = false;
          }
          //  }).catch((e:any)=>{
          //    this.StudyMaterialResponse=e;
          //    this.toastr.error(this.StudyMaterialResponse.statusText);
          //    this.save_submitted1=false;
          //  }
          //  )
        },
        (error) => {
          this.StudyMaterialResponse = error;
          this.toaster.error(this.StudyMaterialResponse.statusText);
          this.save_submitted1 = false;
          console.log(error);
        }
      );
    this.save_submitted1 = true;
    //}
  }

  loading: any;
  shortLink: any;
  progress: any;
  message: any;
  path: any;
  currentFile: any;

  uploadfileflag: boolean = false;
  filelocationname: boolean = false;

  file: any;
  filetype: any;
  Errormessage: any;
  async handleFileButtonClick(fileInput: HTMLInputElement) {
    const formValue = this.AddStudyMaterialform.getRawValue();

    const confirmed = await this.openFileViewer();
    if (confirmed) {
      fileInput.click(); // ✅ Now triggered directly from user event
    }
  }
  async openFileViewer(): Promise<boolean> {
    const formValue = this.AddStudyMaterialform.getRawValue();
    if(!formValue.Study_Material_Type_Code){
      this.toaster.error('Please Select Study Material Type first.');
      return false
    }
    // Prevent upload if a file already exists
    if (formValue.FileUpload || (this.AddStudyMaterialform.get('File_Object_Id')?.value &&formValue.File_Del_Ind === 'N')) {
      this.toaster.error('Please Delete Existing file first.');
      return false;
    }
    const hasExistingUrl = !!formValue.Study_Material_Url;
    if (hasExistingUrl) {
      try {
        const result = await this.modalService.open(
          'Confirmation',
          'A Study material link is already available for this Study material. Do you want to remove it and upload a file?',
          'Yes',
          'No'
        );

        if (!result) {
          return false;
        }

        this.AddStudyMaterialform.get('Study_Material_Url')?.disable();
        this.AddStudyMaterialform.get('Study_Material_Url')?.setValue('');
      } catch (error) {
        // Modal dismissed
        this.AddStudyMaterialform.get('FileUpload')?.setValue(null);
        if (formValue.File_Object_Id) {
          this.AddStudyMaterialform.get('File_Del_Ind')?.setValue('Y');
        }
        console.log('Modal dismissed:', error);
        return false;
      }
    }
    return true;
  }

async onChange(event: any, fileInput: HTMLInputElement) {
  const formValue = this.AddStudyMaterialform.getRawValue();

  // Prevent upload if a file already exists
  if (
    formValue.FileUpload ||
    (this.AddStudyMaterialform.get('File_Object_Id')?.value &&
      formValue.File_Del_Ind === 'N')
  ) {
    this.toaster.error('Please Delete Existing file first.');
    return;
  }

  const newFile = event.target.files[0];
  if (!newFile) return;

  // -------------------------
  // FILE TYPE VALIDATION
  // -------------------------
  const videoTypes = ['video/mp4', 'video/x-matroska', 'video/quicktime'];
  // mp4, mkv, mov

  const isVideoType =
    formValue.Study_Material_Type_Code === 'ClassVideo' ||
    formValue.Study_Material_Type_Code === 'Sup-Video';

  if (isVideoType) {
    // only mp4, mkv, mov
    if (!videoTypes.includes(newFile.type)) {
      this.toaster.error('Only MP4, MKV, or MOV files are allowed.');
      fileInput.value = '';
      return;
    }
  } else {
    // only pdf
    if (newFile.type !== 'application/pdf') {
      this.toaster.error('Only PDF file is allowed.');
      fileInput.value = '';
      return;
    }
  }

  // -------------------------
  // PROCESS FILE
  // -------------------------
  this.message = null;
  this.Filenameflag = false;
  this.file = newFile;

  this.AddStudyMaterialform.patchValue({
    FileUpload: newFile,
    Study_Material_Url: '',
    File_Location_NameAndFileName: null,
  });

  this.AddStudyMaterialform.get('Study_Material_Url')?.disable();

  if (!this.EditStudyMaterialflag) return;

  // Editing case
  if (this.currentInput === newFile.name) {
    const isSameDate = this.compareFileDates(
      newFile.lastModifiedDate,
      this.modifydatetime
    );

    if (isSameDate) {
      this.Filenameflag = false;
      this.AlertPopup.emit(this.Modalclose);
    } else {
      this.Filenameflag = false;
      this.ReplaceAlertPopup.emit(this.Modalclose);
    }
  }
}

  shortenString(str:string, limit = 12) {
  if (typeof str !== 'string') return '';
  return str.length > limit ? str.slice(0, limit) + '...' : str;
  }
  private clearFile(fileInput: HTMLInputElement) {
    this.file = null;
    fileInput.value = '';
  }

  private compareFileDates(fileDate: Date, originalDate: Date): boolean {
    const d = new Date(fileDate);
    d.setHours(d.getHours() - 5);
    d.setMinutes(d.getMinutes() - 30);
    const latest = this.pipe.transform(d, 'yyyy-MM-ddTHH:mm:ss');
    const old = this.pipe.transform(originalDate, 'yyyy-MM-ddTHH:mm:ss');
    return latest === old;
  }

  error1: any = { isError: false, errorMessage: '' };
  check: boolean = false;
  error: any = { isError: false, errorMessage: '' };
  check1: boolean = false;
  FileValidation() {
    if (this.file != undefined && this.file != null) {
      if (this.file.type != null && this.file.type != '') {
        if (this.file.type == 'image/png') {
          this.filetype = 'Image';
          //this.check=true;
          this.check = false;
        } else if (this.file.type == 'image/jpeg') {
          this.filetype = 'Image';
          //this.check=true;
          this.check = false;
        } else if (this.file.type == 'video/mp4') {
          this.filetype = 'Video';
          this.check = true;
        } else if (this.file.type == 'application/pdf') {
          this.filetype = 'PDF';
          this.check = true;
        } else if (this.file.type == 'text/plain') {
          this.filetype = 'Text';
          //this.check=true;
          this.check = false;
        } else {
          this.check = false;
        }
      } else {
        let newstr: string;
        //  newstr = this.file.Type.name.split(".");
        newstr = this.file.name.split('.').pop();
        if (newstr == 'doc') {
          this.filetype = 'Text';
          //this.check=true;
          this.check = false;
        } else if (newstr == 'mov') {
          this.filetype = 'Video';
          this.check = true;
        } else if (newstr == 'ppt') {
          this.filetype = 'Text';
          //this.check=true;
          this.check = false;
        } else if (newstr == 'docx') {
          this.filetype = 'Text';
          //this.check=true;
          this.check = false;
        } else {
          this.check = false;
        }
      }

      if (this.check) {
        this.error1 = { isError: false, errorMessage: '' };
      } else {
        this.error1 = {
          isError: true,
          errorMessage: 'File Not Supported(.mp4,.mov,.pdf)',
        };
        // .png,.jpeg,.mp4,.ppt,.mov,.doc,.docx,.pdf,.txt
        this.AddStudyMaterialform.controls['File_Name'].setValue(null);
      }

      if (!this.error1.isError) {
        var format = /[!@#$%^&*()+\=\[\]{};':"\\|,.<>\/?]+/;
        var name = this.file.name.substr(0, this.file.name.lastIndexOf('.'));
        if (format.test(name)) {
          this.error1 = {
            isError: true,
            errorMessage:
              'File Name Not Supported Avoid ' + format + 'special character',
          };
          // .png,.jpeg,.mp4,.ppt,.mov,.doc,.docx,.pdf,.txt
          this.AddStudyMaterialform.controls['File_Name'].setValue(null);
        } else {
          this.error1 = { isError: false, errorMessage: '' };
        }
      }
    }
  }

  Descriptionvaluelength: any;
  DescriptionMaxlength: any;
  Descriptioncount() {
    this.DescriptionMaxlength = 4000;
    if (
      this.AddStudyMaterialform.controls.Description_Text.value != '' &&
      this.AddStudyMaterialform.controls.Description_Text.value != null
    ) {
      if (
        this.AddStudyMaterialform.controls.Description_Text.value.length > 0
      ) {
        this.Descriptionvaluelength =
          this.AddStudyMaterialform.controls.Description_Text.value.length;
      } else {
        this.Descriptionvaluelength = 0;
      }
    } else {
      this.Descriptionvaluelength = 0;
    }
    this.Editformvalidation();
  }

  Editformvalidation() {
    if (this.EditStudyMaterialflag) {
      if (
        this.AddStudyMaterialform.controls['Study_Material_Type_Code'].valid &&
        this.AddStudyMaterialform.controls['Study_Material_Level_Type'].valid &&
        this.AddStudyMaterialform.controls['Study_Material_Name'].valid
      ) {
        // if(this.AddStudyMaterialform.valid)
        console.log('editvalidation');
        var Study_Material_Type_Code =
          this.AddStudyMaterialform.controls['Study_Material_Type_Code'].value;
        var Study_Material_Level_Type =
          this.AddStudyMaterialform.controls['Study_Material_Level_Type'].value;
        var Study_Material_Name =
          this.AddStudyMaterialform.controls['Study_Material_Name'].value;
        var Description_Text =
          this.AddStudyMaterialform.controls['Description_Text'].value;

        if (
          Study_Material_Type_Code !=
          this.StudyMateriallist.Study_Material_Type_Code
        ) {
          this.tempvariable = true;
          console.log(this.StudyMateriallist.Study_Material_Type_Code);
        } else if (
          Study_Material_Level_Type !=
          this.StudyMateriallist.Study_Material_Level_Type_Code
        ) {
          this.tempvariable = true;
          console.log(this.StudyMateriallist.Study_Material_Level_Type_Code);
        } else if (
          Study_Material_Name != this.StudyMateriallist.Study_Material_Name
        ) {
          this.tempvariable = true;
          console.log(this.StudyMateriallist.Study_Material_Name);
        } else if (
          Description_Text != this.StudyMateriallist.Description_Text
        ) {
          this.tempvariable = true;
          console.log(this.StudyMateriallist.Description_Text);
        } else {
          this.tempvariable = false;
        }
      }
    }
  }

  clickpreviewbutton() {
    const formValue = this.AddStudyMaterialform.getRawValue();
    console.log(formValue.Study_Material_Type_Code);

    if (formValue.Study_Material_Type_Code==='ClassVideo'||formValue.Study_Material_Type_Code==='Sup-Video') {
      const modalRef = this.ngModalService.open(FilePreviewModalComponent, {
        centered: true,
        size: 'lg',
      });
      modalRef.componentInstance.videoUrl = new URL(environment.apiBaseUrl).origin +
          formValue.File_Location_Name +
          '/' +
          (formValue.File_Name_In_Server || '');;
    } else {
      let list = {
        Formvalue: formValue,
        StudyMateriallist: this.StudyMateriallist,
      };
      this.contentpreview.emit(list);
    }
  }
  openStudyMaterialPreview(event: MouseEvent): void {
  event.preventDefault();

  const url = this.AddStudyMaterialform.get('Study_Material_Url')?.value;
  if (!url) {
    return;
  }

  const width = 800;
  const height = 600;
  const left = window.screenX + (window.outerWidth - width) / 2;
  const top = window.screenY + (window.outerHeight - height) / 2;

  window.open(
    url,
    '_blank',
    `toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=${width},height=${height},top=${top},left=${left}`
  );
}

  ClkReviewButton(data: any) {
    let list = {
      Formvalue: this.AddStudyMaterialform.value,
      StudyMateriallist: this.StudyMateriallist,
    };
    this.contentreview.emit(list);
  }

  onStudyMaterialTypeCodeChange(event: any) {
    console.log(event?.target?.value);
    const type = event?.target?.value;
    if (type === 'Question') {
      this.AddStudyMaterialform.controls['Study_Material_Name'].setValidators([
        Validators.required,
      ]);
    } else {
      this.AddStudyMaterialform.controls[
        'Study_Material_Name'
      ].clearValidators();
    }
  }

  AddSubmitReview(data: any) {
    let list = {
      Content_status: data,
      Content: this.StudyMateriallist,
      Content_text: null,
    };

    this.ClickContentstatus.emit(list);
  }

  getStudyMaterialApplication(studyMaterialId: number, studymaterial: any) {
    return zip(
      this.service
        .GetStudyMaterialApplicableCoursePlan(
          UserAuthDetails.getUserLoggedInId(),
          studyMaterialId
        )
        .pipe(
          map((accu: any) => {
            return accu.GetStudyMaterialApplicableCoursePlan;
          })
        ),
      this.service
        .getStudyMaterialApplicableCourseCategory(
          UserAuthDetails.getUserLoggedInId(),
          studyMaterialId
        )
        .pipe(
          map((accu: any) => {
            return accu.GetStudyMaterialApplicableCourseCategory;
          })
        )
    );
  }
}
